import React from 'react';
import { Checkbox, Row, Stack, Text } from 'library/ui';

export default function LocationRow({
    name,
    addressLine,
    createdBy,
    highlight,
    checked,
    disabled,
    onToggle,
    children,
}: {
    name?: string | null;
    addressLine: string;
    createdBy?: string;
    highlight: boolean;
    checked: boolean;
    disabled: boolean;
    onToggle: (checked: boolean) => void;
    children?: React.ReactNode;
}) {
    return (
        <Row justify="between">
            <Stack gap="none">
                <Text weight="medium">{name || 'No location name found'}</Text>
                <Text size="sm" tone="secondary">
                    {addressLine}
                </Text>
                {(!!createdBy || highlight) && (
                    <Row gap="sm" wrap>
                        {!!createdBy && (
                            <Text size="xs" tone="secondary">
                                {`Created by ${createdBy}`}
                            </Text>
                        )}
                        {highlight && (
                            <Text size="xs" tone="secondary">
                                This location
                            </Text>
                        )}
                    </Row>
                )}
                {children}
            </Stack>
            <Checkbox
                checked={checked}
                onChange={(value) => {
                    if (disabled) return;
                    onToggle(value);
                }}
            />
        </Row>
    );
}
